import {
  Component, ElementRef, Inject, NgZone, OnInit,
  ViewChild
} from '@angular/core';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';
import {
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
import { MapsInformationService } from '../services/maps-information.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})
export class MapComponent implements OnInit {
  @ViewChild('search')
  public searchElementRef!: ElementRef;
  @ViewChild(GoogleMap)
  public map!: GoogleMap;
  @ViewChild(MapInfoWindow, { static: false })
  info!: MapInfoWindow;

  zoom = 15;
  center!: google.maps.LatLngLiteral;
  options: google.maps.MapOptions = {
    zoomControl: false,
    scrollwheel: true,
    disableDefaultUI: true,
    fullscreenControl: true,
    disableDoubleClickZoom: true,
    mapTypeId: 'roadmap',
    // maxZoom:this.maxZoom,
    // minZoom:this.minZoom,
  };
  latitude!: any;
  longitude!: any;
  marker: any = [];
  infoContent: string | undefined = '';
  addressName = '';
  addressComponents: any;


  private address: any = {};
  public latitud = '';
  public longitud = '';
  public optionsMarker: google.maps.MapOptions = { draggable: true };
  public dataCountry: any;
  private googleFields = [
    {
      googleField: 'street_number',
      appField: 'externalNumber',
    },
    {
      googleField: 'postal_code',
      appField: 'postalCode',
    },
    {
      googleField: 'route',
      appField: 'street',
    },
    {
      googleField: 'political',
      appField: 'colony',
    },
    {
      googleField: 'administrative_area_level_1',
      appField: 'state',
    },
    {
      googleField: 'locality',
      appField: 'delegation',
    },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogReference: MatDialogRef<MapComponent>,
    private ngZone: NgZone,
    private mapsInformationService: MapsInformationService,
  ) { }

  openInfo(marker: MapMarker, content: string) {
    this.infoContent = content;
    this.info.open(marker);
  }

  closeDialog() {
    const maps = {
      address: this.address,
      marker: this.marker,
      addressName: this.addressName
    }
    this.dialogReference.close(maps);
  }

  ngAfterViewInit(): void {
    const options = {
      componentRestrictions: { country: ['col', 'cl', 'mx'] },
      strictBounds: true,
    };
    // Binding autocomplete to search input control
    const autocomplete = new google.maps.places.Autocomplete(
      this.searchElementRef.nativeElement,
      options
    );
    // Align search box to center
    this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
      this.searchElementRef.nativeElement
    );
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        //get the place result
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();

        //verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        this.dropMarker(
          '',
          place.geometry.location?.lat(),
          place.geometry.location?.lng(),
          place
        );

        //set latitude, longitude and zoom
        this.latitude = place.geometry.location?.lat();
        this.longitude = place.geometry.location?.lng();
        this.center = {
          lat: this.latitude,
          lng: this.longitude,
        };
      });
    });
  }

  ngOnInit() {
    navigator.geolocation.getCurrentPosition((position) => {
      this.center = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    });
  }

  eventHandler(event: any, name: string) {
    this.dropMarker(event);
  }

  dropMarker(
    event?: any,
    lat?: any,
    lng?: any,
    place?: google.maps.places.PlaceResult
  ) {
    if (event) {
      const geocoder = new google.maps.Geocoder();
      const latlng = new google.maps.LatLng(
        event.latLng.lat(),
        event.latLng.lng()
      );
      const request = {
        location: latlng,
      };
      geocoder.geocode(request, (results, status) => {
        if (status == google.maps.GeocoderStatus.OK) {
          if (results?.[0]) {
            this.info.close();
            this.addressName = results?.[0].formatted_address;
            this.addressComponents = results?.[0].address_components;
            this.dataGoogle(this.addressComponents);
            this.marker = null;
            this.marker = new google.maps.Marker({
              position: {
                lat: event.latLng.lat(),
                lng: event.latLng.lng(),
              },
              title: this.addressName,
            });
          }
        }
      });
    } else {
      this.marker = new google.maps.Marker({
        position: {
          lat: lat,
          lng: lng,
        },
        title: place?.formatted_address,
      });
    }

  }

  dataGoogle(addressComponents: google.maps.GeocoderAddressComponent[]) {
    this.googleFields.forEach(
      (field) => (this.address[field.appField] = this.googleValue(field.googleField, addressComponents)),
    );
  }

  googleValue(field: string, addressComponents: google.maps.GeocoderAddressComponent[]): string | undefined {
    const googleField = addressComponents.find((a) =>
      a.types.find((type) => type === field),
    );
    return googleField?.long_name;
  }
}
